<template>
  <div :style="{
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '60px',
  }">
    <template v-if="image">
      <div class="image-box">
        <el-image
          v-if="image"
          :style="imageStyle"
          :src="image"
          :preview-src-list="[image]"
          lazy
        />
      </div>
    </template>
    <template v-else>
      <img
        :style="{
          margin: '5px auto 0',
          width: `80px`,
          height: `80px`,
          textAlign: 'center',
          color: textColor,
          border: imageBorder,
          fontSize: textFontSize
        }"
        src="@/assets/images/error.png"
      >
    </template>
  </div>
</template>
<script>
/**
 * @name 图片预览组件
 * @intro 该组件可以通过点击图片查看放大图片，没有图片可以显示图片缺省图
 */
export default {
  name: 'PreviewImage2',
  props: {
    image: {
      type: String,
      default: ''
    },
    // 图片
    imageArr: {
      type: Array,
      default: () => []
    },
    width: {
      type: Number,
      default: 80
    },
    height: {
      type: [Number, String],
      default: 80
    },
    imageStyle: {
      type: Object,
      default: () => {
        return {
          width: '100%',
          height: 'auto',
          display: 'block'
        }
      }
    },
    imageBorder: {
      type: String,
      default: '3px solid #f1f1f1'
    },
    imageBoxShadow: {
      type: String,
      default: '0 0 4px rgba(0,0,0,.2)'
    },
    textColor: {
      type: String,
      default: 'rgba(0,0,0,.1)'
    },
    textFontSize: {
      type: String,
      default: '12px'
    }
  },
  data() {
    return {}
  },
  methods: {
    errorImg(e) {
      console.log(e)
    }
  }
}
</script>
<style lang="scss" scoped>
.image-box{
  padding: 10px 0;
  margin: 0 auto;
  width: 80%;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  // background-color: #f1f1f1;
  .image-count{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background-color: rgba(0,0,0,.5);
    color: #f9f9f9;
    font-size: 12px;
  }
}
.el-image-viewer__close{
  color: #fff;
}
::v-deep .el-image-viewer__close{
  color: #fff;
}
</style>
